<template>
    <div id="apiary-weather-widget-component">
        <WidgetWrapperComponent :title="$t('global_apiary.local_vision')" id-widget="apiary-weather-widget">
            <template v-slot:default>
                <div class="d-flex justify-center gap-5">
                    <div class="text-center">
                        <p class="mb-0 font-weight-bold font-18">{{ weather?.current?.temp_c }}°C</p>
                        <img :src="`https:${weather?.current?.condition?.icon}`" height="60" />
                    </div>

                    <div class="font-color-medium">
                        <p class="mb-0 font-16 font-color-medium">
                            {{ moment().format(getFormatDateBaseOnLanguage().dateFormat) }}
                        </p>
                        <div class="d-flex align-center font-18">
                            <v-icon class="font-color-medium" size="large">mdi-map-marker-outline</v-icon>
                            <span class="font-color-medium"> {{ weather?.location.name }} </span>
                        </div>
                        <div class="d-flex align-center font-14">
                            <v-icon class="font-color-medium" size="large">mdi-water-outline</v-icon>
                            <span class="font-color-medium"> {{ weather?.current.precip_mm }} mm </span>
                        </div>
                    </div>
                </div>

                <div class="d-flex gap-2 flex-wrap justify-space-around">
                    <div
                        v-for="forecast in weather?.forecast.forecastday"
                        :key="forecast.date"
                        class="rounded-xl px-6 py-2 text-center weather-day-card-border"
                    >
                        <p class="mb-0">{{ moment(forecast.date).format('dddd') }}</p>
                        <img :src="`https:${forecast?.day?.condition?.icon}`" height="40" />

                        <div class="d-flex gap-1 justify-center font-14">
                            <span class="font-color-normal">{{ forecast.day.maxtemp_c }}°C</span>
                            <span class="font-color-light">{{ forecast.day.mintemp_c }}°C</span>
                        </div>

                        <div class="d-flex align-center justify-center font-10">
                            <v-icon class="font-color-medium" size="large">mdi-water-outline</v-icon>
                            <span class="font-color-medium">{{ forecast.day.totalprecip_mm }}mm</span>
                        </div>
                    </div>
                </div>
            </template>
        </WidgetWrapperComponent>
    </div>
</template>

<script>
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'
import ApiaryRepository from '@/repositories/ApiaryRepository'

export default {
    name: 'ApiaryWeatherWidgetComponent',
    components: { WidgetWrapperComponent },
    props: {
        apiary: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fetching_weather: true,
            weather: {},
        }
    },
    created() {
        this.getWeatherByIdApiary()
    },
    watch: {
        apiary() {
            this.getWeatherByIdApiary()
        },
    },
    methods: {
        getWeatherByIdApiary() {
            this.fetching_weather = true

            ApiaryRepository.getWeatherByIdApiary(this.apiary.id_apiary)
                .then((success) => {
                    this.weather = success.data.data
                })
                .catch((error) => {
                    this.manageError(error)
                })
                .finally(() => {
                    this.fetching_weather = false
                })
        },
    },
}
</script>

<style>
.weather-day-card-border {
    border: 2px var(--v-primary-base) solid;
}
</style>
